<template lang="pug">
BookingDetails
</template>

<script>
import { mapActions } from 'vuex'
import BookingDetails from './tabs/BookingDetails.vue'

export default {
  name: 'BookingDetailsWrapper',
  components: { BookingDetails },
  props: {
    bookingKey: { type: String, required: true },
  },
  methods: {
    ...mapActions('bookingDetails', ['fetchBookingDetails']),
  },
  async mounted() {
    await this.fetchBookingDetails(this.bookingKey)
  },
}
</script>
